import PropTypes from 'prop-types';
import React from 'react';
import { GraduationCap, Pencil } from 'lucide-react';
import { formatYearRange } from 'helpers/portfolioLayout';
import styles from '../../CareerEntries.module.scss';

const EducationDetails = ({ education, onEdit, isOwn, user }) => (
  <div className={styles.entry}>
    <span className={styles.iconTile} aria-hidden="true">
      <GraduationCap size={18} strokeWidth={2} />
    </span>
    <div className={styles.body}>
      <div className={styles.titleRow}>
        <span className={styles.title}>
          {education.qualification}
          {education.organization && (
            <span className={styles.issuer}> · {education.organization}</span>
          )}
        </span>
        <span className={styles.dates}>
          {formatYearRange(education.started_at, education.ended_at)}
        </span>
      </div>
      {education.content && (
        <p className={styles.description}>{education.content}</p>
      )}
    </div>
    {user && isOwn && (
      <button
        type="button"
        className={styles.editEntryBtn}
        onClick={onEdit}
        aria-label={`Edit ${education.qualification || 'education'}`}
      >
        <Pencil size={15} strokeWidth={2} aria-hidden="true" />
      </button>
    )}
  </div>
);

EducationDetails.propTypes = {
  education: PropTypes.object,
  onEdit: PropTypes.func,
  isOwn: PropTypes.bool,
  user: PropTypes.object,
};

export default EducationDetails;
